import {
	mapState
} from 'vuex';

import {
	Popover
} from 'element-ui';

export default {
	name: 'agenda-viewers',
	components: {
		Popover
	},
	computed: {
		...mapState({
			agenda: (state) => state.Agenda.agenda
		})
	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/agenda-viewers/index.js